 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-auth-forgot-password-forgot-password-module":"pages-auth-forgot-password-forgot-password-module","pages-auth-new-login-new-login-module":"pages-auth-new-login-new-login-module","default~pages-ai-manager-role-ai-manager-role-module~pages-automatic-challenges-automatic-challenges~d40028fa":"default~pages-ai-manager-role-ai-manager-role-module~pages-automatic-challenges-automatic-challenges~d40028fa","default~pages-ai-manager-role-ai-manager-role-module~pages-automatic-challenges-automatic-challenges~0acb3a6b":"default~pages-ai-manager-role-ai-manager-role-module~pages-automatic-challenges-automatic-challenges~0acb3a6b","pages-notifications-send-notification-send-notification-module":"pages-notifications-send-notification-send-notification-module","default~pages-ai-manager-role-ai-manager-role-module~pages-automatic-challenges-automatic-challenges~ce691e8a":"default~pages-ai-manager-role-ai-manager-role-module~pages-automatic-challenges-automatic-challenges~ce691e8a","default~pages-automatic-challenges-automatic-challenges-module~pages-challenge-quiz-challenge-quiz-m~028bdcc6":"default~pages-automatic-challenges-automatic-challenges-module~pages-challenge-quiz-challenge-quiz-m~028bdcc6","default~pages-automatic-challenges-automatic-challenges-module~pages-challenge-template-challenge-te~23d3ab74":"default~pages-automatic-challenges-automatic-challenges-module~pages-challenge-template-challenge-te~23d3ab74","default~pages-automatic-challenges-automatic-challenges-module~pages-challenge-template-challenge-te~0cf98675":"default~pages-automatic-challenges-automatic-challenges-module~pages-challenge-template-challenge-te~0cf98675","pages-automatic-challenges-automatic-challenges-module":"pages-automatic-challenges-automatic-challenges-module","default~pages-challenge-quiz-challenge-quiz-module~pages-my-company-my-company-module~pages-reward-r~27c04eeb":"default~pages-challenge-quiz-challenge-quiz-module~pages-my-company-my-company-module~pages-reward-r~27c04eeb","default~pages-my-company-my-company-module~pages-praise-colleague-praise-colleague-module":"default~pages-my-company-my-company-module~pages-praise-colleague-praise-colleague-module","pages-my-company-my-company-module":"pages-my-company-my-company-module","pages-challenge-quiz-challenge-quiz-module":"pages-challenge-quiz-challenge-quiz-module","pages-reward-reward-module":"pages-reward-reward-module","pages-wellness-wellness-module":"pages-wellness-wellness-module","default~pages-challenge-template-challenge-template-module~pages-dashboard-analytics-dashboard-analy~99ac140b":"default~pages-challenge-template-challenge-template-module~pages-dashboard-analytics-dashboard-analy~99ac140b","default~pages-challenge-template-challenge-template-module~pages-dashboard-analytics-dashboard-analy~60cff7ff":"default~pages-challenge-template-challenge-template-module~pages-dashboard-analytics-dashboard-analy~60cff7ff","default~pages-challenge-template-challenge-template-module~pages-dashboard-analytics-dashboard-analy~b80e2c6a":"default~pages-challenge-template-challenge-template-module~pages-dashboard-analytics-dashboard-analy~b80e2c6a","pages-challenge-template-challenge-template-module":"pages-challenge-template-challenge-template-module","pages-challenges-invite-invite-module":"pages-challenges-invite-invite-module","pages-event-event-module":"pages-event-event-module","pages-praise-colleague-praise-histroy-praise-histroy-module":"pages-praise-colleague-praise-histroy-praise-histroy-module","pages-wellness-categories-wellness-categories-module":"pages-wellness-categories-wellness-categories-module","default~pages-challenges-challenge-detail-challenge-detail-module~pages-dashboard-analytics-dashboar~688d49d1":"default~pages-challenges-challenge-detail-challenge-detail-module~pages-dashboard-analytics-dashboar~688d49d1","pages-dashboard-analytics-dashboard-analytics-module":"pages-dashboard-analytics-dashboard-analytics-module","pages-ai-manager-role-ai-manager-role-module":"pages-ai-manager-role-ai-manager-role-module","pages-notifications-notifications-module":"pages-notifications-notifications-module","pages-slack-intergration-slack-intergration-module":"pages-slack-intergration-slack-intergration-module","pages-manager-teams-manager-teams-module":"pages-manager-teams-manager-teams-module","pages-manager-actions-manager-actions-module":"pages-manager-actions-manager-actions-module","pages-praise-colleague-praise-colleague-module":"pages-praise-colleague-praise-colleague-module","pages-challenges-create-edit-challenge-create-edit-challenge-module":"pages-challenges-create-edit-challenge-create-edit-challenge-module","pages-manager-ai-manager-ai-module":"pages-manager-ai-manager-ai-module","pages-challenges-challenge-detail-challenge-detail-module":"pages-challenges-challenge-detail-challenge-detail-module","default~pages-change-password-change-password-module~pages-my-organisation-my-organisation-module~pa~7923a609":"default~pages-change-password-change-password-module~pages-my-organisation-my-organisation-module~pa~7923a609","default~pages-my-organisation-my-organisation-module~pages-user-profile-user-profile-module":"default~pages-my-organisation-my-organisation-module~pages-user-profile-user-profile-module","pages-my-organisation-my-organisation-module":"pages-my-organisation-my-organisation-module","pages-user-profile-user-profile-module":"pages-user-profile-user-profile-module","pages-change-password-change-password-module":"pages-change-password-change-password-module","pages-auth-inivated-user-page-inivated-user-module":"pages-auth-inivated-user-page-inivated-user-module","pages-auth-reset-password-reset-password-module":"pages-auth-reset-password-reset-password-module","pages-coaching-coaching-module":"pages-coaching-coaching-module","pages-errors-error-404-error-404-module":"pages-errors-error-404-error-404-module","pages-errors-error-500-error-500-module":"pages-errors-error-500-error-500-module","pages-errors-permission-denied-permission-denied-module":"pages-errors-permission-denied-permission-denied-module","pages-monthly-themes-monthly-themes-module":"pages-monthly-themes-monthly-themes-module","quill":"quill","challenges-challenges-module":"challenges-challenges-module","group-challenges-group-challenges-details-group-challenges-details-module":"group-challenges-group-challenges-details-group-challenges-details-module","on-going-edit-on-going-edit-on-going-module":"on-going-edit-on-going-edit-on-going-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
